import { shortDate } from "@/lib/api";

export const NightPicker = ({ nights, value, onChange, compact = false }) => (
  <div className={`grid gap-3 ${compact ? "grid-cols-2 sm:grid-cols-3" : "grid-cols-2 sm:grid-cols-3"}`} data-testid="night-picker">
    {nights.map((n) => {
      const d = shortDate(n.date);
      const active = value === n.id;
      return (
        <button key={n.id} type="button" disabled={n.sold_out} onClick={() => onChange(n.id)}
          data-testid={`night-option-${n.id}`}
          className={`relative rounded-md border p-3 text-left sm:p-4 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-40 ${
            active ? "border-[#C9A24B] bg-[#C9A24B]/15" : "border-white/15 bg-white/[0.04] hover:border-[#C9A24B]/60"}`}>
          <span className="block font-mono text-[11px] uppercase tracking-widest text-[#BDB3A5]">{d.weekday} · {d.year}</span>
          <span className="mt-1 block font-display text-xl text-white">{d.month} {d.day}</span>
          <span className="mt-1 block text-[11px] font-bold uppercase tracking-wider text-[#D9B864]">{n.label || "Show night"}</span>
          {n.city && <span className="mt-0.5 block text-[11px] text-[#BDB3A5]" data-testid={`night-city-${n.id}`}>{n.city}</span>}
          {n.sold_out ? <span className="mt-2 block text-[11px] uppercase tracking-wider text-red-400">Sold out</span>
            : n.remaining <= 10 && <span className="mt-2 block text-[11px] uppercase tracking-wider text-[#E8C878]">{n.remaining} seats left</span>}
        </button>
      );
    })}
  </div>
);
